import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { generatePageWithTabsRoute } from './routeGenerator';
import { usageRouteDefinitions } from './UsageRouteDefinitions';

const UsageRoutes: RouteObject = generatePageWithTabsRoute(
  'Explore usage by utility',
  BASE.USAGE,
  NESTED_ROUTES.USAGE.ELECTRIC,
  usageRouteDefinitions,
);

export default UsageRoutes;
